import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ModalController, NavController, ToastController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { UserProfile } from '../../models/user-profile.model';
import { UtilService } from '../../service/util.service';
import { ReportService } from '../report/report.service';
import { RecalculateStockService } from './recalculate-stock.service';
import { PromotionDetailComponent } from '../../component/promotion-detail/promotion-detail.component';

@Component({
  selector: 'app-recalculate-stock',
  templateUrl: './recalculate-stock.page.html',
  styleUrls: ['./recalculate-stock.page.scss'],
})
export class RecalculateStockPage implements OnInit {

  warehouseList: any[] = [];
  formRecalculateStock: FormGroup;
  year: any;
  month: any;
  monthName: any;
  userProfile: UserProfile = new UserProfile();
  token: any;
  mstProductList:any=[];
  mstProductGimmickList:any=[];
  listProductDisplay:any='';
  productId:any=[];
  productScan:any='';

  warehouseId:number=0;
  constructor(
    private storage: Storage,
    private navCtrl: NavController,
    private fb: FormBuilder,
    private utilService: UtilService,
    private toastCtrl: ToastController,
    private modalController: ModalController,
    private recalculateStockService: RecalculateStockService
  ) { }

  ngOnInit() {
    let todayDate = new Date();
    let convertDate = this.utilService.convertDate(todayDate);
    this.month = convertDate.months;
    this.buildRecalculateStockForm();
    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile')
    ])
    .then(([token, profile]) => {
      if(token) {
        this.token = token;
        this.userProfile = new UserProfile(profile);
        this.getWarehouse();
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Silahkan login terlebih dahulu.' }).then(t => t.present());
        this.navCtrl.navigateForward(['/login']);
      }
    });
  }

  buildRecalculateStockForm() {
    this.formRecalculateStock = this.fb.group({
      stockDate: [],
      warehouseId: []
    });
  }

  getWarehouse() {
    let options = {
      "token": this.token,
      "counter_id": this.userProfile.counter_id_pos !== 0 ? this.userProfile.counter_id_pos : this.userProfile.counter_id_list
    }

    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      this.recalculateStockService.getWarehouse(options).subscribe((response) => {
        this.utilService.loadingDismiss();
        if(response.status.code === 200) {
          this.warehouseList = response.results.warehouse_data;
          this.mstProductList = response.results.mst_product;
          this.mstProductGimmickList = response.results.mst_product_gimmick;
        }
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      });
    });
  }

  recalculate() {
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      const recalculateStock = this.formRecalculateStock.getRawValue();
      let dateConvert = this.utilService.convertDate(recalculateStock.stockDate);
      this.year = dateConvert.years;
      this.month = dateConvert.months;
      let body = {
        warehouse_id: this.warehouseId,//recalculateStock.warehouseId,
        year: this.year,
        month: this.month,
        product_id:this.productId
      };
      
      this.recalculateStockService.recalculateStock(body).subscribe((response) => {
        this.utilService.loadingDismiss();
        if(response.status.code === 200) {
          this.toastCtrl.create({ duration: 2000, message: 'Sukses' }).then(t => t.present());
        } else {
          this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
        }
      }, (err) => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      });
    });
  }
  public selectWarehouse(event){
    this.warehouseId = event.value.id;
  }
  async openListProduct() {
    let product_id = [];
    const modal = await this.modalController.create({
      component: PromotionDetailComponent,
      componentProps: {
        'token':this.token,
        'counterId':this.warehouseId,
        'mstProductList': this.mstProductList,
        "mstProductGimmickList":this.mstProductGimmickList,
        "productScan":this.productScan,
        "stockData":[],
        'viewOnly':"N",
        "action":"product"
      },
      backdropDismiss: false
    });

    modal.onDidDismiss().then((modelData) => {
      if (modelData.data !== '') {
        let dataProduct: any[] = modelData.data;
        let productList: string = '';
        let productListDisplay: string = '';
        dataProduct.sort((a, b) => a.id.localeCompare(b.id));
        if(dataProduct.length > 0) {
          for(let i = 0; i < dataProduct.length; i++) {
            productList = productList + dataProduct[i].id;
            productListDisplay = productListDisplay + dataProduct[i].id;
            if((i+1) !== dataProduct.length) {
              productList = productList + ';';
              productListDisplay = productListDisplay + ', ';
            }
            product_id.push(dataProduct[i].id);
          }
        }
        this.productScan = productList;
        this.productId = product_id;
        this.listProductDisplay = productListDisplay;
      }
    });
    return await modal.present();
  }
}
